import React, { useState } from 'react';
import styled from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import ArtAsset from './ArtAsset';
import LoadingSpinner from '../../../../ui/components/LoadingSpinner';
import { GameArt } from '../../../../backend/useGameArt';
import Tooltip from '../../../../ui/components/Tooltip';
import Button from '../../../../ui/components/Button';

const Inner = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    gap: 10px;
`;

interface ArtInnerProps {
    gameArtAssets: GameArt[];
    loading: boolean;
    selectedArtIndex: number | null;
    updatingArtIds: Set<string>;
    onArtClick: (artIndex: number) => void;
}

const ArtInner: React.FC<ArtInnerProps> = ({
    gameArtAssets,
    loading,
    selectedArtIndex,
    updatingArtIds,
    onArtClick
}) => {

    const buttons = (
        <>
            <Tooltip text="Swap" colorMode="dark" >
                <Button
                    size="tiny"
                    color="white" 
                    icon="swap" 
                    onClick={()=>{}} 
                />
            </Tooltip>
            <Tooltip text="Edit" colorMode="dark" >
                <Button
                    size="tiny"
                    color="white" 
                    icon="edit-2" 
                    onClick={()=>{}} 
                />
            </Tooltip>
        </>
    );    

    return (
        <Inner>
            {loading ? (
                <LoadingSpinner size="medium" colorMode="dark" />
            ) : (
                gameArtAssets.length > 0 ? (
                    gameArtAssets.map((art, index) => (
                        <ArtAsset 
                            key={art.id || index} 
                            art={{ 
                                image: art.asset_url,
                                name: art.asset_name || `Game Art ${index + 1}`
                            }} 
                            isSelected={index === selectedArtIndex}
                            isLoading={!!art.id && updatingArtIds.has(art.id)}
                            onClick={() => onArtClick(index)}
                            isDisabled={false}
                            // buttons={buttons}
                        />
                    ))
                ) : (
                    <div style={{ color: Colors.grey3, textAlign: 'center', padding: '20px 0' }}>
                        No game art available
                    </div>
                )
            )}
        </Inner>
    );
};

export default ArtInner;